import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatEnumName } from '../../../constants/utils';

const getStatusBadgeClass = (status) => {
    if (!status) return 'bg-secondary';

    const s = status.toUpperCase();

    switch (s) {
        case 'ONLINE':
        case 'IN_USE':
        case 'STANDBY':
        case 'ACTIVE':
            return 'bg-success';
        case 'OFFLINE':
        case 'OFFLINE_PLANNED':
        case 'PLANNED_DOWNTIME':
        case 'OFFLINE_UNPLANNED':
        case 'UNPLANNED_DOWNTIME':
        case 'INACTIVE':
            return 'bg-danger';
        case 'DO_NOT_TRACK':
        case 'AVAILABLE':
        case 'UNAVAILABLE':
        case 'DECOMMISSIONED':
        case 'DISPOSED':
        case 'NONE':
        default:
            return 'bg-secondary';
    }
};

const AssetStatusBadge = ({ status, className = '' }) => {
    const { t } = useTranslation();

    if (!status) {
        return <span className="text-muted">-</span>;
    }

    const badgeClass = getStatusBadgeClass(status);
    const label = t(`shared.${status.toLowerCase()}`, formatEnumName(status));

    return (
        <span className={`badge ${badgeClass} ${className}`.trim()}>
            {label.toUpperCase()}
        </span>
    );
};

export default AssetStatusBadge;
